module.exports = __webpack_public_path__ + "img/insurance-icon.973f4042.svg";